"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),t=require("prop-types"),a=require("./ReactCalendar/Calendar.js"),n=require("styled-components"),r=require("@vds-core/utilities"),o=require("@vds-tokens/color"),l=require("@vds-tokens/layout"),i=require("@vds-tokens/typography"),s=require("@vds-tokens/form-controls"),c=require("@vds-tokens/accessibility"),d=require("@vds-core/button-icons"),u=require("@vds-core/icons/left-caret"),p=require("@vds-core/icons/right-caret"),m=require("@vds-core/typography");function h(e){return e&&e.__esModule?e:{default:e}}var v=h(e),g=h(t),f=h(n),y=h(u),_=h(p);const k="320px";v.default.createElement("svg",{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 21.6 21.6"},v.default.createElement("path",{d:"M7.6,20.7L5,18.1l7.3-7.3L5,3.5l2.5-2.5l9.9,9.9L7.6,20.7z"})),v.default.createElement("svg",{id:"Layer_1","data-name":"Layer 1",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21.6 21.6"},v.default.createElement("polygon",{points:"6.71 19.8 5.89 18.981 14.07 10.799 5.89 2.619 6.71 1.8 15.71 10.799 6.71 19.8"})),v.default.createElement("svg",{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 21.6 21.6"},v.default.createElement("path",{d:"M14.1,20.7l-9.9-9.9l9.9-9.9l2.5,2.5l-7.3,7.3l7.3,7.3L14.1,20.7z"})),v.default.createElement("svg",{id:"Layer_1","data-name":"Layer 1",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21.6 21.6"},v.default.createElement("polygon",{points:"14.89 19.8 5.89 10.799 14.89 1.8 15.71 2.619 7.53 10.799 15.71 18.981 14.89 19.8"}));const b={onChange:g.default.func,selectedDate:g.default.oneOfType([g.default.string,g.default.instanceOf(Date)]),width:g.default.number,minDate:g.default.instanceOf(Date),maxDate:g.default.instanceOf(Date),transparentBackground:g.default.bool,activeDates:g.default.array,inactiveDates:g.default.array,hideCurrentDateIndicator:g.default.bool,indicators:g.default.arrayOf(g.default.shape({label:g.default.string,date:g.default.instanceOf(Date)})),hideContainerBorder:g.default.bool,dateSelectionSize:g.default.number,surface:g.default.oneOf(["light","dark"])},w={selectedDate:void 0,onChange:()=>{},width:void 0,minDate:new Date,hideCurrentDateIndicator:!1,dateSelectionSize:40,transparentBackground:!1,surface:"light",hideContainerBorder:!1,isOpen:!0},T=f.default.div.withConfig({displayName:"CalendarWrapper",componentId:"VDS__sc-lzg9bq-0"})`
  position: ${({datePicker:e})=>e?"absolute":"relative"};
  top: ${({datePicker:e,calendarPosition:t})=>e?r.calculateRem(t):0};

  @media screen and (max-width: 359px) {
    left: 50%;
    transform: translateX(-50%);
  }
`,$=f.default.span.withConfig({displayName:"IconWrapper",componentId:"VDS__sc-lzg9bq-1"})`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:focus {
    outline: none;
  }
  height: ${r.calculateRem(44)};
  width: ${r.calculateRem(44)};
`;f.default.div.withConfig({displayName:"IconSVGWrapper",componentId:"VDS__sc-lzg9bq-2"})`
  display: flex;
  height: ${({iconSize:e})=>r.calculateRem(e)};
  width: ${({iconSize:e})=>r.calculateRem(e)};
  min-height: ${({iconSize:e})=>r.calculateRem(e)};
  min-width: ${({iconSize:e})=>r.calculateRem(e)};
  ${({tabIndex:e})=>e<0&&"\n    outline: none;\n    pointer-events: none;\n  "};
  &:active,
  &:focus {
    outline: none;
  }
  ${({surface:e})=>n.css`
    svg {
      polygon,
      path {
        fill: ${o.ColorTokens.elements.primary["dark"===e?"ondark":"onlight"].value};
      }
    }
  `}
`;const x=f.default(a.Calendar).withConfig({displayName:"StyledCalendar",componentId:"VDS__sc-lzg9bq-3"})`
  &.react-calendar {
    z-index: 5;
    background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
    box-sizing: content-box;
    ${({hideContainerBorder:e,surface:t})=>!e&&`\n    border: ${r.calculateRem(1)} solid\n      ${"dark"===t?o.ColorTokens.elements.primary.ondark.value:o.ColorTokens.elements.primary.onlight.value};\n    `}
    position: relative;
    border-radius: ${s.FormControlsTokens.border.radius.value};
    padding: ${r.calculateRem(l.LayoutTokens.space["1X"].value,0)};
    width: ${r.calculateRem(326)};
    min-width: ${r.calculateRem(318)};
    font-family: ${m.Fonts.VerizonNHGeTX};
    button {
      &:active,
      &:hover,
      &:visited {
        outline: none;
      }
    }
  }

  .react-calendar__month-view {
    padding: 0;
  }

  .react-calendar__month-view__weekdays {
    padding-bottom: ${null};
    justify-content: ${null};
    text-align: center;
    justify-content: center;

    .react-calendar__month-view__weekdays__weekday {
      margin: ${r.calculateRem(6,6)};
      color: ${({surface:e})=>"dark"===e?o.ColorTokens.interactive.active.ondark.value:o.ColorTokens.interactive.active.onlight.value};
      box-sizing: content-box;
      font-size: ${r.calculateRem(i.TypographyTokens.fontsize.body[12].value)};
      font-family: ${m.Fonts.VerizonNHGeTX};
      font-weight: ${i.TypographyTokens.fontweight.regular.value};
      line-height: ${r.calculateRem(i.TypographyTokens.lineheight.body[16].value)};
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${r.calculateRem(l.LayoutTokens.space["8X"].value)};
      height: ${r.calculateRem(l.LayoutTokens.space["8X"].value)};
    }

    abbr[title] {
      font-family: ${m.Fonts.VerizonNHGeTX};
      text-decoration: none;
    }
  }

  .react-calendar__navigation__label {
    border: none;
    color: ${({surface:e})=>"dark"===e?o.ColorTokens.elements.primary.ondark.value:o.ColorTokens.elements.primary.onlight.value};
    font-size: ${r.calculateRem(i.TypographyTokens.fontsize.body[12].value)};
    font-family: ${m.Fonts.VerizonNHGeTX};
    font-weight: ${i.TypographyTokens.fontweight.bold.value};
    line-height: ${r.calculateRem(i.TypographyTokens.lineheight.body[16].value)};
    padding: 0;
    margin: ${`${r.calculateRem(0)} ${r.calculateRem(l.LayoutTokens.space["5X"].value)}`};
    cursor: pointer;
    outline: none;
    display: flex;
    flex: 1;
    justify-content: center;
  }

  .react-calendar__viewContainer {
    margin: ${r.calculateRem(0,parseInt(s.FormControlsTokens.space.inset.value)-1,parseInt(s.FormControlsTokens.space.inset.value)-1,parseInt(s.FormControlsTokens.space.inset.value)-1)};
  }

  @media screen and (max-width: ${k}) {
    .react-calendar__viewContainer {
      margin: ${r.calculateRem(0,parseInt(l.LayoutTokens.space["2X"].value)-1,12,parseInt(l.LayoutTokens.space["2X"].value)-1)};
    }
  }

  .react-calendar__navigation {
    background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
    margin: ${r.calculateRem(parseInt(l.LayoutTokens.space["3X"].value)-1,parseInt(s.FormControlsTokens.space.inset.value)-1,0,parseInt(s.FormControlsTokens.space.inset.value)-1)};
    padding: ${r.calculateRem(14)};
    flex: 1;
    display: flex;
  }

  @media screen and (max-width: ${k}) {
    .react-calendar__navigation {
      margin: ${r.calculateRem(parseInt(l.LayoutTokens.space["3X"].value)-1,parseInt(l.LayoutTokens.space["2X"].value)-1,0,parseInt(l.LayoutTokens.space["2X"].value)-1)};
    }
  }

  button::-moz-focus-inner {
    border: 0;
  }

  abbr {
    position: relative;
    z-index: 1;
    text-decoration: none;
  }

  .react-calendar__navigation__next-button {
    right: ${r.calculateRem(parseInt(s.FormControlsTokens.space.inset.value)-1)};

    &:-moz-focus-inner {
      border: 0;
    }
  }

  .react-calendar__navigation__prev-button {
    left: ${r.calculateRem(parseInt(s.FormControlsTokens.space.inset.value)-1)};

    &:-moz-focus-inner {
      border: 0;
    }
  }

  .react-calendar__navigation__next-button[disabled] {
    visibility: hidden;
  }

  .react-calendar__navigation__prev-button[disabled] {
    visibility: hidden;
  }

  .react-calendar__navigation__arrow {
    &:focus {
      outline: none;
      &:not(:hover):not(:visited):not(:active) > ${$} {
        &::after {
          background: transparent;
          border: ${r.calculateRem(1)} dashed
            ${({surface:e})=>"dark"===e?o.ColorTokens.elements.primary.ondark.value:o.ColorTokens.elements.primary.onlight.value};
          box-sizing: border-box;
          content: '';
          height: ${r.calculateRem(24)};
          left: 50%;
          position: absolute;
          border-radius: ${r.calculateRem(c.AccessibilityTokens.focusring.space.offset.value)};
          top: 50%;
          transform: translate(-50%, -50%);
          width: ${r.calculateRem(24)};
        }
      }
    }

    &:-moz-focus-inner {
      border: 0;
    }
  }

  .react-calendar__navigation__next-button,
  .react-calendar__navigation__prev-button {
    align-items: center;
    border: 0;
    background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
    cursor: pointer;
    display: flex;
    height: ${r.calculateRem(44)};
    justify-content: center;
    padding: 0;
    position: absolute;
    top: ${r.calculateRem(14)};
    width: ${r.calculateRem(44)};
    z-index: 1;

    &:focus {
      outline-offset: -${r.calculateRem(l.LayoutTokens.space["2X"].value)};
    }
  }

  .react-calendar__navigation__next2-button,
  .react-calendar__navigation__prev2-button {
    display: none;
  }

  .react-calendar__year-view__months {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__decade-view__years {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__decade-view__years {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__century-view__decades {
    display: flex;
    flex-wrap: wrap;
  }

  /* Day tiles */
  .react-calendar__month-view__days {
    display: flex;
    flex-wrap: wrap;
  }

  .react-calendar__tile {
    background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
    border: none;
    box-sizing: content-box;
    color: ${({disabled:e,surface:t})=>e&&"dark"!==t?o.ColorTokens.interactive.disabled.onlight.value:e&&"dark"===t?o.ColorTokens.interactive.disabled.ondark.value:"dark"===t?o.ColorTokens.elements.primary.ondark.value:o.ColorTokens.elements.primary.onlight.value};
    flex-basis: auto !important;
    font-size: ${r.calculateRem(i.TypographyTokens.fontsize.body[12].value)};
    font-family: ${m.Fonts.VerizonNHGeTX};
    font-weight: ${i.TypographyTokens.fontweight.regular.value};
    line-height: ${r.calculateRem(i.TypographyTokens.lineheight.body[16].value)};
    overflow: visible !important;
    padding: 0;
    position: relative;
    pointer-events: auto;

    &.react-calendar__month-view__days__day {
      height: ${r.calculateRem(44)};
      width: ${r.calculateRem(44)};
    }

    &:hover:not(.react-calendar__month-view__days__day--neighboringMonth),
    &.react-calendar__tile--active,
    &.react-calendar__tile--hover,
    &.react-calendar__tile--rangeStart,
    &.react-calendar__tile--rangeEnd,
    &.react-calendar__tile--rangeBothEnds {
      color: ${({surface:e})=>"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
      cursor: pointer;
      &::before {
        background-color: ${({surface:e})=>"dark"===e?o.ColorTokens.elements.primary.ondark.value:o.ColorTokens.elements.primary.onlight.value};
        content: '';
        height: ${({dateSelectionSize:e})=>r.calculateRem(e)};
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: ${({dateSelectionSize:e})=>r.calculateRem(e)};
        box-sizing: border-box;
        border-radius: ${r.calculateRem(l.LayoutTokens.space["1X"].value)};
      }
    }

    &:hover:not(.react-calendar__tile--active) {
      &:hover {
        color: ${({surface:e})=>"dark"===e?o.ColorTokens.elements.primary.ondark.value:o.ColorTokens.elements.primary.onlight.value};
        &::before {
          background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
          border-radius: ${r.calculateRem(l.LayoutTokens.space["1X"].value)};
          box-sizing: border-box;
          border: ${({surface:e})=>"dark"===e?`${r.calculateRem(1)} solid ${o.ColorTokens.elements.primary.ondark.value}`:`${r.calculateRem(1)} solid ${o.ColorTokens.elements.primary.onlight.value}`};
        }
      }
    }

    &:focus {
      background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
      outline: none;
      + svg {
        outline: none;
      }
      &:not(:hover):not(:visited):not(:active) {
        &::after {
          background: transparent;
          border: ${({surface:e})=>"dark"===e?`${r.calculateRem(1)} dashed ${o.ColorTokens.elements.primary.ondark.value}`:`${r.calculateRem(1)} dashed ${o.ColorTokens.elements.primary.onlight.value}`};
          box-sizing: border-box;
          border-radius: ${r.calculateRem(6)};
          content: '';
          height: ${r.calculateRem(44)};
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: ${r.calculateRem(44)};
        }
      }
    }

    &:disabled {
      color: ${({surface:e})=>"dark"===e?o.ColorTokens.interactive.disabled.ondark.value:o.ColorTokens.interactive.disabled.onlight.value};

      &:hover {
        background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
        color: ${({surface:e})=>"dark"===e?o.ColorTokens.interactive.disabled.ondark.value:o.ColorTokens.interactive.disabled.onlight.value};
        cursor: default;
      }

      &:hover:not(.react-calendar__month-view__days__day--neighboringMonth),
      &.react-calendar__tile--hover,
      &.react-calendar__tile--rangeStart,
      &.react-calendar__tile--rangeEnd,
      &.react-calendar__tile--rangeBothEnds {
        color: ${({surface:e})=>"dark"===e?o.ColorTokens.interactive.disabled.ondark.value:o.ColorTokens.interactive.disabled.onlight.value};
        &::before {
          background-color: transparent;
          border: none;
        }
      }
    }
    &.react-calendar__tile--now:not([disabled]) {
      font-weight: ${({hideCurrentDateIndicator:e})=>e?i.TypographyTokens.fontweight.regular.value:i.TypographyTokens.fontweight.bold.value};
      &:hover:not(.react-calendar__tile--active):not([disabled]) {
        &:hover {
          font-weight: ${({hideCurrentDateIndicator:e})=>e?i.TypographyTokens.fontweight.regular.value:i.TypographyTokens.fontweight.bold.value};
        }
      }
      &.react-calendar__tile--active:not([disabled]) {
        font-weight: ${({hideCurrentDateIndicator:e})=>e?i.TypographyTokens.fontweight.regular.value:i.TypographyTokens.fontweight.bold.value};
      }
    }
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: ${o.ColorTokens.interactive.disabled.onlight.value};
    font-weight: ${i.TypographyTokens.fontweight.regular.value};
    opacity: 0;
    pointer-events: none;
  }

  @media screen and (max-width: 359px) {
    &.react-calendar {
      padding: ${r.calculateRem(l.LayoutTokens.space["1X"].value,0)};
      width: ${({customWidth:e})=>e?r.calculateRem(e):r.calculateRem(318)};
      min-width: ${({customWidth:e})=>e?r.calculateRem(e):r.calculateRem(318)};
    }
  }
  .react-calendar__navigation button[disabled] {
    background-color: ${({surface:e,transparentBackground:t})=>t?"transparent":"dark"===e?o.ColorTokens.elements.primary.onlight.value:o.ColorTokens.elements.primary.ondark.value};
  }
`;class C extends v.default.Component{constructor(e){super(e),this._toggleNextHoverOn=()=>this.setState({nextHovered:!0}),this._toggleNextHoverOff=()=>this.setState({nextHovered:!1}),this._togglePrevHoverOn=()=>this.setState({prevHovered:!0}),this._togglePrevHoverOff=()=>this.setState({prevHovered:!1}),this.calendarPos=()=>{const e=void 0!==typeof document&&document.getElementById(this.props.inputId+"-label");this.setState({calendarPosition:e&&e.clientHeight+52})},this._setAttributes=()=>{this.monthLabel="undefined"!=typeof document?document.getElementsByClassName("react-calendar__navigation__label"):null,this.allButtons="undefined"!=typeof document?document.getElementsByClassName("react-calendar__tile"):null,this.selectedButton="undefined"!=typeof document?document.getElementsByClassName("react-calendar__tile--active"):null,[].slice.call(this.allButtons).forEach((e=>{let t=e.querySelectorAll("abbr")[0],a=t.getAttribute("aria-label");e===this.selectedButton[0]?(t.setAttribute("aria-live","assertive"),a.includes("selected")||t.setAttribute("aria-label",`${a} selected`)):(a=a.split(" selected")[0],t.removeAttribute("aria-live"),t.setAttribute("aria-label",a))}))},this._findNextDay=(e,t)=>{const{parse:a}=Date;let n=!1;if(t&&t.map((t=>{let r="string"==typeof t?new Date(a(t)):t;a(r)===a(e)&&(n=!0)})),n){const a=new Date(e);return a.setDate(e.getDate()+1),this._findNextDay(a,t)}return e},this._findEarliestDay=(e,t)=>{const{parse:a}=Date;let n=!1,r=new Date(864e13);return t&&t.map((t=>{let o="string"==typeof t?new Date(a(t)):t;a(o)===a(e)?(r=o,n=!0):a(o)<a(r)&&!n&&(r=o)})),r},this._getDate=()=>{const{error:e,selectedDate:t,inactiveDates:a,activeDates:n}=this.props,{parse:r}=Date;if(e)return null;if(null===t)return null;let o,l,i;return o=!0===t||void 0===t||""===t?new Date:t,o="string"==typeof o?new Date(r(o)):o,a?(l=!0===a?"":a,o.setHours(0,0,0,0),this._findNextDay(o,l)):n?(i=!0===n?"":n,o.setHours(0,0,0,0),this._findEarliestDay(o,i)):o},this._onChange=e=>{this.setState({selectedDate:e}),void 0!==this.props.onChange&&this.props.onChange(e)},this._onClickDay=(e,t)=>{0!==t.screenX&&0!==t.screenY&&t.currentTarget.blur()},this._toggleDates=()=>{let e,t;const{inactiveDates:a,activeDates:n}=this.props;if(a&&a.length)e=a,t=!0;else{if(!n||!n.length)return null;e=n,t=!1}return({date:a})=>e.filter((e=>{const t=new Date(e);return t.setHours(0,0,0,0),a.getTime()===t.getTime()})).length?t:!t},this.isMobileDevice=r.checkIfMobileDevice(),this._renderNextLabel=(e,t)=>{const{surface:a}=this.props;return v.default.createElement($,{tabIndex:-1},v.default.createElement(d.ButtonIcon,{kind:"ghost",size:"40px",surface:a,onClick:e,iconOffset:{x:2,y:0},ariaLabel:"view next month",disabled:t&&t,renderIcon:e=>v.default.createElement(_.default,Object.assign({},e,{size:16}))}))},this._renderPrevLabel=(e,t)=>{const{surface:a}=this.props;return v.default.createElement($,{tabIndex:-1},v.default.createElement(d.ButtonIcon,{kind:"ghost",size:"40px",surface:a,onClick:e,iconOffset:{x:-2,y:0},ariaLabel:"view previous month",disabled:t&&t,renderIcon:e=>v.default.createElement(y.default,Object.assign({},e,{size:16}))}))},this.state={selectedDate:this._getDate(),nextHovered:!1,prevHovered:!1,calendarPosition:void 0}}componentDidMount(){this._setAttributes(),this.calendarPos()}componentDidUpdate(e){e&&e.selectedDate!==this.props.selectedDate&&this.setState({selectedDate:this.props.selectedDate}),this._setAttributes(),"undefined"!=typeof window&&window.addEventListener("resize",this.calendarPos)}componentWillUnmount(){"undefined"!=typeof window&&window.removeEventListener("resize",this.calendarPos)}render(){const{disabled:e,minDate:t,maxDate:a,surface:n,hideCurrentDateIndicator:r,dateSelectionSize:o,indicators:l,transparentBackground:i}=this.props,{selectedDate:s}=this.state,c={weekday:"long",year:"numeric",month:"long",day:"numeric"};return l&&l.splice(3),v.default.createElement(v.default.Fragment,null,this.props.isOpen&&v.default.createElement(T,{isOpen:this.props.isOpen,alwaysOpen:this.props.alwaysOpen,datePicker:this.props.datePicker,calendarPosition:this.state.calendarPosition},v.default.createElement(x,Object.assign({},this.props,{transparentBackground:i,minDetail:"month",maxDetail:"month",disabled:e,showNeighboringMonth:!1,isOpen:this.props.isOpen,customWidth:this.props.width,calendarType:"US",formatLongDate:(e,t)=>t.toLocaleDateString("en",c),formatShortWeekday:(e,t)=>["S","M","T","W","T","F","S"][t.getDay()],tabIndex:0,nextAriaLabel:"view next month",onNextMouseEnter:this._toggleNextHoverOn,onNextMouseLeave:this._toggleNextHoverOff,nextLabel:this._renderNextLabel,onChange:this._onChange,prevAriaLabel:"view previous month",onPrevMouseEnter:this._togglePrevHoverOn,onPrevMouseLeave:this._togglePrevHoverOff,prevLabel:this._renderPrevLabel,value:s,minDate:t,maxDate:a,tileDisabled:this._toggleDates(),onClickDay:this._onClickDay,surface:n,hideCurrentDateIndicator:r,dateSelectionSize:o,indicators:l}))))}}C.propTypes=b,C.defaultProps=w,exports.default=C;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/cjs/components/Calendar.js
// module id = 851
// module chunks = 0